import React from 'react';
import SelectOrderStrategy from "./SelectOrderStrategy";
import {OrderExecutorEditStrategies} from "../../../../app/order/GetStrategies";

const SelectOrderExecutorEditStrategy = React.forwardRef(({onChange, ...props}, ref) => (
    <SelectOrderStrategy onChange={onChange} strategies={OrderExecutorEditStrategies} {...props} ref={ref}/>
));

export default SelectOrderExecutorEditStrategy;